module.exports = require('./dist/browserRuntime');
